import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, OnDestroy } from '@angular/core';
import { ɵSharedStylesHost, ɵgetDOM } from '@angular/platform-browser';
import { CSP_NONCE_TOKEN } from 'src/app/share/tokens/csp-nonce.token';

@Injectable()
export class CustomDomSharedStylesHost extends ɵSharedStylesHost implements OnDestroy {
  private _hostNodes = new Map<Node, Node[]>();

  constructor(
    @Inject(DOCUMENT) private _doc: Document,
    @Inject(CSP_NONCE_TOKEN) private nonce: string,
  ) {
    super();
    this._hostNodes.set(_doc.head, []);
  }

  ngOnDestroy(): void {
    this._hostNodes.forEach((styleNodes) => styleNodes.forEach(removeStyle));
  }

  private _addStylesToHost(
    styles: Set<string>,
    host: Node,
    styleNodes: Node[]
  ): void {
    const nonce = this.nonce;
    styles.forEach((style: string) => {
      const styleEl = this._doc.createElement('style');
      styleEl.textContent = style;
      styleEl.setAttribute('nonce', nonce); // Add nonce
      styleNodes.push(host.appendChild(styleEl));
    });
  }

  addHost(hostNode: Node): void {
    const styleNodes: Node[] = [];
    this._hostNodes.set(hostNode, styleNodes);
  }

  removeHost(hostNode: Node): void {
    const styleNodes = this._hostNodes.get(hostNode);
    if (styleNodes) {
      styleNodes.forEach(removeStyle);
    }
    this._hostNodes.delete(hostNode);
  }

  /** @override */
  onStylesAdded(additions: Set<string>): void {
    this._hostNodes.forEach((styleNodes, hostNode) => {
      this._addStylesToHost(additions, hostNode, styleNodes);
    });
  }

}

function removeStyle(styleNode: Node): void {
  ɵgetDOM().remove(styleNode);
}